<template>
  <v-layout column>
    <activities-tab-navbar>
      <v-btn small text icon color="accent" @click="exitActivityDetails">
        <v-icon>arrow_back_ios</v-icon>
      </v-btn>

      <v-flex class="subheading font-weight-bold">
        {{ $tc("Activity", 1) }} {{ activity.title }}
      </v-flex>

      <list-edition-toolbar
        v-if="mode === 'tasks'"
        :buttons="toolbarButtons"
        horizontal-alignment="right"
        @add="$emit('addTask')"
      />

      <toggle-buttons
        v-model="mode"
        :buttons="toggleButtons"
        style="margin: 6px 8px"
      />
    </activities-tab-navbar>

    <activity-form
      v-if="mode === 'details'"
      :activity="activity"
      :tasks="tasks"
      @update="getActivity"
      @delete="exitActivityDetails"
    />

    <tasks-table
      v-if="mode !== 'details'"
      :tasks="tasks"
      @openTask="$emit('openTask', $event)"
    />
  </v-layout>
</template>

<script>
import TasksTable from "./ActivityDetailsTasks";
import ActivitiesTabNavbar from "../ActivitiesTabNavbar";
import ActivityForm from "./ActivityDetailsForm";
import ListEditionToolbar from "@/components/Home/Forms/_Molecules/ListEditionToolbar";
import ToggleButtons from "@/components/_Atoms/AppToggleButtons";
import { mapActions } from "vuex";

export default {
  name: "ObjectFormActivityDetails",

  components: {
    ToggleButtons,
    ListEditionToolbar,
    ActivityForm,
    ActivitiesTabNavbar,
    TasksTable
  },

  props: {
    activityUuid: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      activity: {},
      tasks: [],
      mode: "tasks"
    };
  },

  computed: {
    toolbarButtons() {
      return Object.keys(this.activity).length > 0 ? [
        {
          id: "add",
          icon: "add_circle",
          tooltip: this.$i18n.t("AddTask"),
          active: this.activity.state !== 'completed'
        }
      ] :
      [];
    },

    toggleButtons() {
      return [
        { value: "tasks", text: this.$i18n.tc("Task", 2) },
        { value: "details", text: this.$i18n.tc("Detail", 2) }
      ];
    }
  },

  mounted() {
    this.getActivity();
  },

  methods: {
    ...mapActions([
      "fetchActivity",
      "fetchTasksByActivityUuid",
      "saveActivity"
    ]),

    async getActivity() {
      try {
        this.activity = await this.fetchActivity({
          activityUUID: this.activityUuid,
          includes: "fibercloudObject"
        });
        this.tasks = await this.fetchTasksByActivityUuid({ uuid: this.activityUuid });
        this.saveActivity(this.activity.due_date);
      } catch (e) {
        console.log(e);
      } finally {
      }
    },

    exitActivityDetails() {
      this.$emit("return");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Activities/ActivityDetails/ActivityDetails.vue